export default "__VITE_ASSET__Jj0dAX7P__"